export default "__VITE_ASSET__BhFCD15H__"